import React, { memo, useCallback } from 'react';
import Div from '@/shared/Div';
import Map from '@/components/Map';
import Heading from '@/shared/Heading';
import Container from '@/shared/Container';
import InformationCard from '@/shared/crisp/InformationCard';
import CTAs from '@/shared/crisp/CTAs';
import VideoCard from '@/components/Static/VideoCard';
import Paragraph from '@/shared/Paragraph';
import classNames from 'classnames';
import withContentFlags from '@/hoc/withContentFlags';

interface AMCServiceFiltersProps {
  title: string;
  subTitle: string;
  ctas: any[];
  list: any[];
  videoCard?: {
    title: string;
    mobileImage?: string;
    desktopImage?: string;
    video?: {
      poster: string;
    };
  };
}

const AMCServiceFilters = (props: AMCServiceFiltersProps) => {
  const { title, subTitle, ctas, list, videoCard } = props;
  const { mobileImage, desktopImage, video } = videoCard ?? {};
  const render = useCallback((item: any, index: number) => {
    const key = `amc-service-filters-${item.id}-${index}`;
    return (
      <InformationCard
        key={key}
        className={classNames(
          'flex-shrink-0 !flex-none md:!flex-1 w-48 md:w-full whitespace-break-spaces inline-block',
        )}
        dataTestId={key}
        {...item}
      />
    );
  }, []);

  return (
    <Div className="py-s8 md:py-s9 bg-cs-secondary text-center" style={{ background: '#F3F8FF' }}>
      <Container>
        <Heading level={3} className="text-h-1 md:text-hd-1 text-cm-primary px-s6 md:px-0">
          {title}
        </Heading>
        <Paragraph className="body-base sm:body-lg mt-s3 px-s6 md:px-0">{subTitle}</Paragraph>
        <CTAs
          list={ctas || []}
          dataTestId="service-and-filters"
          className="mt-s5 !inline-block !bg-extended-brand"
        />
        <Div className="grid grid-cols-1 md:grid-cols-2 gap-s6 mt-s6 text-left">
          <Map
            className="flex md:flex-wrap md:grid grid-cols-2 gap-s5 overflow-x-auto hide-scrollbar whitespace-nowrap -mx-6 px-6"
            list={list}
            render={render}
          />
          {videoCard && (
            <Div className="">
              <VideoCard
                title={videoCard.title}
                mobileImage={mobileImage}
                desktopImage={desktopImage}
                video={video}
              />
            </Div>
          )}
        </Div>
      </Container>
    </Div>
  );
};

export default withContentFlags(memo(AMCServiceFilters));
